import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Toast, ToastContainer } from 'react-bootstrap';

import { hideSnapshotSuccessToast } from '../../store/toasts';

const SnapshotSuccessToast = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector((store) => store.toasts.snapshotSuccess);
  const count = useSelector((store) => store.toasts.snapshotCount);

  return (
    <ToastContainer position="top-center" style={{ position: 'fixed', zIndex: 1100 }}>
      <Toast
        onClose={() => dispatch(hideSnapshotSuccessToast())}
        show={isVisible}
        bg="success"
        delay={5000}
        autohide
      >
        <Toast.Body className="text-white">
          Snapshot taken successfully. Count:&nbsp;
          {count}
          .
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default SnapshotSuccessToast;
